/**
 * Truncates a text string to a specified length
 * @param text - The text string to truncate
 * @param length - The maximum length of the truncated string
 * @returns The truncated string with '...' appended if the text was longer than the specified length
 */
export const truncateText = (text: string, length: number): string => {
  if (!text) return "";
  if (text.length <= length) return text;
  return text.slice(0, length) + "...";
};
